"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestInterceptor = exports.requestErrorInterceptor = exports["default"] = exports.API_HOST = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var API_HOST = exports.API_HOST = process.env.REACT_APP_SERVER_HOST;
var axios = _axios["default"].create({
  baseURL: "".concat(API_HOST),
  withCredentials: false,
  headers: {
    "Content-Type": "application/json"
  }
});
var requestInterceptor = exports.requestInterceptor = function requestInterceptor(config) {
  var token = _jsCookie["default"].get("access_token");
  if (token && !config.headers["X-Skip-Auth"]) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  delete config.headers["X-Skip-Auth"];
  return config;
};
var requestErrorInterceptor = exports.requestErrorInterceptor = function requestErrorInterceptor(error) {
  return Promise.reject(error instanceof Error ? error : new Error(String(error)));
};
axios.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
var _default = exports["default"] = axios;